module.exports = {
      id: "twitter-icon-usage",
      viewBox: "0 0 135.08 135.08",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#twitter-icon",
      toString: function () {
        return this.url;
      }
    }